import { useGetServicesQuery } from '../../__generated__/chirp/com/hubspot/service/catalog/rpc/ServiceCatalogServiceRpc.hooks';
import { Service } from 'marketplace-ui-common/services/ServiceCatalogTypes';

export function useGetCatalogServices({ skip }: { skip?: boolean }): {
  catalogServices: Service[] | undefined;
  loading: boolean;
} {
  const { data, loading } = useGetServicesQuery({ variables: {}, skip });
  return {
    catalogServices: data?.services as Service[] | undefined,
    loading,
  };
}
